import script from "./post.vue?vue&type=script&setup=true&lang=ts"
export * from "./post.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__